import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const getRecentlyViewedResources = async (teamId?: string) => {
  const userId = await getUserId();
  const { data, error } = await supabase.rpc("get_latest_resources_for_user", {
    p_principal_id: teamId || userId,
    p_viewed_by: userId,
  });

  if (error) {
    throw error;
  }

  return data;
};

export const useRecentlyViewed = (teamId?: string) => {
  return useQuery({
    queryKey: ["recently_viewed", teamId],
    queryFn: () => getRecentlyViewedResources(teamId),
  });
};

export const useRecentlyViewedSubscription = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["recently_viewed_subscription"],
    queryFn: () => {
      const channels = supabase
        .channel("recently_viewed_all")
        .on("postgres_changes", { event: "*", schema: "public", table: "resource_views" }, () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey?.[0] === "recently_viewed",
          });
        })
        .subscribe();
      return () => {
        channels.unsubscribe();
      };
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
